import React from 'react';
import styles from '../styles/SkeletonBubble.module.css';
import chatStyles from '../styles/Interview.module.css';
import { useUiCopy } from '../i18n/useUiCopy';

type SkeletonVariant = 'thinking' | 'processing' | 'analysis';

interface StatusSkeletonProps {
  variant?: SkeletonVariant;
  lines?: number;
  ariaLabel?: string;
}

const StatusSkeleton: React.FC<StatusSkeletonProps> = ({
  variant = 'thinking',
  lines = 3,
  ariaLabel
}) => {
  const copy = useUiCopy();
  const getStatusText = () => {
    switch (variant) {
      case 'thinking':
        return copy.thinking;
      case 'processing':
        return copy.processingResponse;
      case 'analysis':
        return copy.generatingAnalysis;
      default:
        return copy.thinking;
    }
  };

  const getLineWidths = (lineCount: number) => {
    const widthClasses = ['w70', 'w90', 'w55', 'w80', 'w60'];
    return Array.from({ length: lineCount }, (_, index) =>
      widthClasses[index % widthClasses.length]
    );
  };

  const lineWidths = getLineWidths(lines);
  const statusText = getStatusText();
  const effectiveAriaLabel = ariaLabel || `${statusText} ${copy.pleaseWait}`;

  return (
    <div className={`${chatStyles.messageRow} ${chatStyles.ai}`} aria-live="polite" aria-label={effectiveAriaLabel}>
      <div className={chatStyles.avatar}>
        <img src="/isa_portrait.png" alt="ISA Avatar" />
      </div>
      
      <div
        className={`${chatStyles.message} ${chatStyles.ai} ${styles.skeletonBubble}`}
      >
        <div className={styles.skeletonWrapper}>
          {lineWidths.map((widthClass, index) => (
            <div
              key={index}
              className={`${styles.skeletonLine} ${styles[widthClass]}`}
            />
          ))}
        </div>
        <div className={`${styles.statusText} ${styles[variant]}`}>
          {statusText}
        </div>
      </div>
    </div>
  );
};

export default StatusSkeleton;
